/**
 * DOM manipulations is strongly not recommended
 * Could be used only in exceptional cases
 */

/**
 * Replace one child node with another
 *
 * @param parentNode - parent node
 * @param currentChildNode - child node to be replaced
 * @param newChildNode - child node to replace with
 *
 * Usage Example:
 *
 * replaceChildNode(currentFiltersGroup, currentFiltersList[newFilterIndex], newFilter);
 *
 */
export const replaceChildNode = (parentNode, currentChildNode, newChildNode) => {
    parentNode.replaceChild(newChildNode, currentChildNode);
};

/**
 * Insert child node by index position
 *
 * @param parentNode - parent node
 * @param newChildNode - child node to insert
 * @param positionIndex - position by index to insert
 *
 * Usage Example:
 *
 * insertNode(currentFiltersList, newFilter, newFilterIndex);
 *
 */
export const insertNode = (parentNode, newChildNode, positionIndex) => {
    if (positionIndex === 0) {
        parentNode[0].insertAdjacentElement('beforebegin', newChildNode);
    } else {
        parentNode[positionIndex - 1].insertAdjacentElement('afterend', newChildNode);
    }
};

/**
 * Remove the list of child nodes
 *
 * @param parentNode - parent node
 * @param childNodes - the list of child nodes
 * @param from - start position by index to delete
 * @param to - end position by index to delete
 *
 * Usage Example:
 *
 * removeNodes(currentFiltersGroup, currentFiltersList, newFilterIndex, currentFilterIndex - 1);
 *
 */
export const removeNodes = (parentNode, childNodes, from, to) => {
    for (let j = to; j >= from; j--) {
        parentNode.removeChild(childNodes[j]);
    }
};

/**
 * Blur active element
 */
export const blurActiveElement = () => {
    if (document.activeElement) {
        document.activeElement.blur();
    }
};
